<template>
  <div class="community-top-comments">
    <action-dispatcher action="community/getTopComments">
      <h5 class="text-light my-4">Tópicos em destaque</h5>
      <router-link
        v-for="comment in topComments"
        :key="-comment.id"
        :to="{ name: 'community-topic', params: { id: comment.id } }"
        class="text-light d-flex align-items-center text-decoration-none my-3"
      >
        <img v-if="comment.picture" class="mr-2" :src="comment.picture" />
        <div>
          <small class="text-secondary">{{ time(comment) }}</small>
          <h6 class="mb-0">{{ comment.title }}</h6>
          <small
            >{{ comment.count }} resposta{{
              comment.count === 1 ? "" : "s"
            }}</small
          >
        </div>
      </router-link>
    </action-dispatcher>
    <!-- <action-dispatcher action="community/getTopLikes">
      <h5 class="text-light mb-4 mt-5">Tópicos mais curtidos</h5>
      <router-link
        v-for="comment in topLikes"
        :key="-comment.id"
        :to="{ name: 'community-topic', params: { id: comment.id } }"
        class="text-light d-flex align-items-center text-decoration-none my-3"
      >
        <img v-if="comment.picture" class="mr-2" :src="comment.picture" />
        <div>
          <small class="text-secondary">{{ time(comment) }}</small>
          <h6 class="mb-0">{{ comment.title }}</h6>
          <small
            >{{ comment.like }} curtida{{
              comment.like === 1 ? "" : "s"
            }}</small
          >
        </div>
      </router-link>
    </action-dispatcher> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import dayjs from "dayjs";
import "dayjs/locale/pt";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
dayjs.locale("pt");

export default {
  computed: {
    ...mapState("community", ["topLikes", "topComments"])
  },
  methods: {
    time(comment) {
      return dayjs().to(dayjs(comment.created_at).add(3, "hour"));
    }
  }
};
</script>

<style lang="scss" scoped>
.community-top-comments {
  img {
    max-width: 56px;
    max-height: 56px;
    min-width: 56px;
    min-height: 56px;
    object-fit: cover;
  }
}
</style>
